import { lazy } from "react";
import { prefetchGet } from "@/lib/timedRequest";

// Each admin tab's code downloads the first time it's needed; one shared download per tab.
const LOADERS = {
  dashboard: () => import("@/components/admin/DashboardSection"),
  customers: () => import("@/components/admin/CustomersSection"),
  timeclock: () => import("@/components/admin/TimeClockSection"),
  schedule: () => import("@/components/admin/ScheduleSection"),
  bookkeeping: () => import("@/components/admin/BookkeepingSection"),
  invoicing: () => import("@/components/admin/InvoicingSection"),
  estimates: () => import("@/components/admin/EstimatesSection"),
  email: () => import("@/components/admin/EmailSection"),
  team: () => import("@/components/admin/TeamSection"),
  flowchart: () => import("@/components/admin/FlowchartSection"),
  notes: () => import("@/components/NotesModal"),
  invoiceDialog: () => import("@/components/admin/InvoiceDialog"),
};
const TAB_IDS = ["dashboard", "customers", "timeclock", "schedule", "bookkeeping", "invoicing", "estimates", "email", "team", "flowchart"];

const started = {};
const load = (id) => {
  if (!started[id]) started[id] = LOADERS[id]().catch((err) => { delete started[id]; throw err; });
  return started[id];
};
const lazyNamed = (id, name) => lazy(() => load(id).then((m) => ({ default: m[name] })));

export const DashboardSection = lazyNamed("dashboard", "DashboardSection");
export const CustomersSection = lazyNamed("customers", "CustomersSection");
export const TimeClockSection = lazyNamed("timeclock", "TimeClockSection");
export const ScheduleSection = lazyNamed("schedule", "ScheduleSection");
export const BookkeepingSection = lazyNamed("bookkeeping", "BookkeepingSection");
export const InvoicingSection = lazyNamed("invoicing", "InvoicingSection");
export const EstimatesSection = lazyNamed("estimates", "EstimatesSection");
export const EmailSection = lazyNamed("email", "EmailSection");
export const TeamSection = lazyNamed("team", "TeamSection");
export const FlowchartSection = lazyNamed("flowchart", "FlowchartSection");
export const NotesModal = lazyNamed("notes", "NotesModal");
export const InvoiceDialog = lazyNamed("invoiceDialog", "InvoiceDialog");

// Opening /admin/dashboard: start the open tab's code — and the data every tab needs — alongside the
// dashboard frame's download, not after it.
export const preloadOpenAdminTab = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("tab");
    const saved = localStorage.getItem("shs_admin_section");
    const id = [fromUrl, saved].find((t) => TAB_IDS.includes(t)) || "dashboard";
    load(id).catch(() => {});
    prefetchGet("/bookings");
    if (id === "dashboard") ["/dashboard/summary", "/dashboard/money"].forEach(prefetchGet);
  } catch { /* storage unavailable — the tab loads when it renders */ }
};
